"use client";

import React, { useState } from "react";
//import Image from 'next/image';
import { Pen, ArrowLeft } from "lucide-react";
import { Button } from "../../components/ui/button";
import DeletePriceAlert from "../../components/DeletePriceAlert";
import { useNavigate } from "react-router-dom";
import Header from "../../layouts/Header";
import alertsImage from "../../assets/images/settings/alerts.svg";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Separator } from "../../components/ui/separator";

function PriceAlertsPop() {
  return (
    <>
      {/* <div className="flex justify-center mt-8 px-4 md:px-16 lg:px-32">
        <div className="max-w-3xl w-full">
          <Card className="bg-white rounded-2xl shadow-sm overflow-hidden">
            <CardHeader className="px-6 pt-6 pb-4">
              <CardTitle className="text-2xl font-semibold text-text-secondary text-[20px]">Price Alerts</CardTitle>
            </CardHeader>

            <CardContent className="px-6 pb-4 space-y-4">
              <div className="flex justify-between items-center border-solid border-[1px] rounded-[20px] border-gray-200 py-5 px-4">
                <div>
                  <p className="font-semibold text-text-primary text-[16px] ">SOL/ZAR</p>
                  <p className="font-normal text-text-secondary text-[14px] mt-1">Below R500</p>
                </div>
                <div className='flex'>
                  <div className="mr-2 rounded-full p-[8px] border"> 
                    <Pen size={16} strokeWidth={1}/>
                  </div>
                  <DeletePriceAlert/>
                </div>
              </div>
              <div className="flex justify-between items-center border-solid border-[1px] rounded-[20px] border-gray-200 py-5 px-4">
                <div>
                  <p className="font-semibold text-text-primary text-[16px] ">BTC/ZAR</p>
                  <p className="font-normal text-text-secondary text-[14px] mt-1">Below R500</p>
                </div>
                <div className='flex'>
                  <div className="mr-2 rounded-full p-[8px] border"> 
                    <Pen size={16} strokeWidth={1}/>
                  </div>
                  <DeletePriceAlert/>
                </div>
              </div>
            </CardContent>

            <Separator />

            <div className='flex justify-center py-6'>
              <Button className="bg-gradient-to-r from-purple-500 to-pink-500 text-white py-6 rounded-full w-[50%]"
                onClick={() => {
                  //setPageNo('0')
                }}>
                Create new Price Alert 
              </Button>
            </div>
          </Card>
        </div>
      </div> */}

      {/* Main Content */}
      <div className="flex justify-center mt-16 px-4 md:px-16 lg:px-32">
        <div className="max-w-3xl w-full bg-white rounded-2xl shadow-lg p-10 flex flex-col items-center">
          {/* Icon */}
          <img
            src={alertsImage}
            alt="Price Alerts"
            width={100}
            height={100}
            className="mb-6"
          />

          {/* Title and Description */}
          <h2 className="text-xl font-semibold text-gray-800 text-center mb-4">
            You haven’t created any price alerts
          </h2>
          <p className="text-sm text-gray-600 text-center mb-8">
            Your price alerts will appear here.
          </p>

          {/* Create New Price Alert Button */}
          <Button className="bg-gradient-to-r from-pink-500 to-purple-500 text-white px-6 py-2 rounded-full">
            Create new price alert
          </Button>
        </div>
      </div>
    </>
  );
}

function PriceAlertsSetUp() {
  const [priceTog, setPriceTog] = useState("above");

  function priceToggle() {
    if (priceTog == "above") {
      setPriceTog("below");
    } else {
      setPriceTog("above");
    }
  }

  return (
    <>
      <div className="flex justify-center mt-12 px-4 md:px-16 lg:px-32">
        <div className="max-w-3xl w-full">
          <Card className="bg-white rounded-2xl shadow-sm overflow-hidden">
            <CardHeader className="px-9 pt-6 pb-4">
              <CardTitle className="text-2xl font-semibold text-text-secondary text-[20px]">
                <div className="flex items-center">
                  <div>Create a new price alert</div>
                </div>
              </CardTitle>
            </CardHeader>

            <CardContent className="px-5 pt-2  pb-6">
              <div className="grid grid-cols-2 mb-6">
                <div className="px-4">
                  <p className="text-[14px] text-text-secondary font-normal mb-2">
                    Select Asset
                  </p>
                  <input
                    type="text"
                    placeholder=""
                    //value={name}
                    //onChange={(e) => setCurrentPassword(e.target.value)}
                    className="border-[1px] rounded-[10px] border-bg-border text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-white text-[14px] font-normal px-5 py-4"
                  />
                </div>
                <div className="w-full px-4">
                  <p className="text-[14px] text-text-secondary font-normal mb-2">
                    Select Asset
                  </p>
                  <input
                    type="text"
                    placeholder=""
                    //value={name}
                    //onChange={(e) => setCurrentPassword(e.target.value)}
                    className="border-[1px] rounded-[10px] border-bg-border text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-white text-[14px] font-normal px-5 py-4"
                  />
                </div>
              </div>
              <div className="px-4 mb-4">
                <p className="text-[14px] text-text-secondary font-normal mb-4">
                  Notify me when the price of 1 ETH is:
                </p>
                <div className="bg-bg-neutral/30 py-1 px-1 rounded-full">
                  <Button
                    className={
                      priceTog == "above"
                        ? "bg-brand-primary text-white py-2 rounded-full  font-semibold w-[50%]  hover:bg-brand-primary"
                        : "bg-transparent py-2 rounded-full w-[50%] font-semibold text-text-secondary hover:bg-transparent"
                    }
                    onClick={() => {
                      priceToggle();
                    }}
                  >
                    Above
                  </Button>
                  <Button
                    className={
                      priceTog == "below"
                        ? "bg-brand-primary text-white py-2 rounded-full  font-semibold w-[50%]  hover:bg-brand-primary"
                        : "bg-transparent py-2 rounded-full w-[50%] font-semibold text-text-secondary hover:bg-transparent"
                    }
                    onClick={() => {
                      priceToggle();
                    }}
                  >
                    Below
                  </Button>
                </div>
              </div>
              <div className="w-full px-4 mb-4">
                <p className="text-[14px] text-text-secondary font-normal mb-2">
                  Asset Price
                </p>
                <input
                  type="text"
                  placeholder=""
                  //value={name}
                  //onChange={(e) => setCurrentPassword(e.target.value)}
                  className="border-[1px] rounded-[10px] border-bg-border text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-white text-[14px] font-normal px-5 py-4"
                />
              </div>
              <div className="w-full px-4 mb-4 text-center">
                <div className="bg-bg-neutral/30 py-3 px-1 rounded-full ">
                  <p className="text-[14px] text-text-primary font-normal">
                    1 ETH/1 ZAR ≈{" "}
                    <span className="font-semibold">R 65 000</span>
                  </p>
                </div>
              </div>
              <div className="flex justify-center py-4">
                <Button
                  className="bg-gradient-to-r from-purple-500 to-pink-500 text-white py-2 rounded-full w-[50%]"
                  onClick={() => {
                    //setPageNo('0')
                  }}
                >
                  Create new price alert
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
}

const PriceAlerts = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <div className="min-h-screen w-full bg-gray-100 flex flex-col">
        <div className="h-14 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center pl-20 text-white">
          <ArrowLeft
            className="mr-5 bg-transparent rounded-full p-1 border-gray-200/60 border hover:border-gray-400 hover:bg-white/20"
            onClick={() => {
              navigate("/settings/index");
            }}
          />
          <p className="text-sm font-medium underline mr-2">Settings</p>
          <p className="text-sm font-medium"> / Price Alerts</p>
        </div>
        <PriceAlertsPop />
        {/* <PriceAlertsSetUp/> */}
      </div>
    </>
  );
};

export default PriceAlerts;
